import { useState } from 'react';
import type { Stock } from '../../../types/stock';

const MAX_STOCKS = 5;

interface UseStockMultiSelectionParams {
  stocks: Stock[];
  initialStocks?: Stock[];
}

export function useStockMultiSelection({ stocks, initialStocks }: UseStockMultiSelectionParams) {
  const [selectedStocksMap, setSelectedStocksMap] = useState<Map<number, Stock>>(() => {
    if (initialStocks && initialStocks.length > 0) {
      return new Map(initialStocks.map((s) => [s.id, s]));
    }
    return new Map();
  });

  const handleToggleStockSelection = (stockId: number) => {
    const stock = stocks.find((s) => s.id === stockId);
    if (!stock) return;

    setSelectedStocksMap((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(stockId)) {
        newMap.delete(stockId);
      } else {
        if (newMap.size >= MAX_STOCKS) {
          alert(`Ви можете вибрати максимум ${MAX_STOCKS} складів`);
          return prev;
        }
        newMap.set(stockId, stock);
      }
      return newMap;
    });
  };

  return {
    selectedStocksMap,
    handleToggleStockSelection,
  };
}
